var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgregar = function SvgAgregar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "agregar_svg__Capa_2",
    viewBox: "0 0 26.01 26.01"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "agregar_svg__Capa_1-2",
    d: "M12.15.03C5.67.44.44 5.68.03 12.15c-.5 7.84 5.99 14.33 13.83 13.83 6.48-.41 11.71-5.65 12.13-12.13.49-7.83-6-14.32-13.84-13.82m7.72 13.98H14v5.87c0 .55-.45 1-1 1s-1-.45-1-1v-5.87H6.13c-.55 0-1-.45-1-1s.45-1 1-1H12V6.14c0-.55.45-1 1-1s1 .45 1 1v5.87h5.87c.55 0 1 .45 1 1s-.45 1-1 1",
    fill: "#fff"
  })));
};
export default SvgAgregar;